import * as z from 'zod'

/**
 * A resilient replacement for raw `.optional()` on complex Zod types.
 *
 * When an optional property has an unexpected or invalid shape, a plain
 * `.optional()` would throw a parse error and potentially break the page.
 * `safeOptional` catches those mismatches and falls back to `undefined`,
 * so malformed optional data is silently ignored instead of crashing the site.
 */
export const safeOptional = <T extends z.ZodType>(schema: T) => {
  return z
    .unknown()
    .transform((val): z.infer<T> | undefined => {
      if (val === undefined) {
        return undefined
      }

      const result = schema.safeParse(val)

      if (result.success) {
        return result.data
      }

      return undefined
    })
    .optional()
}
